import React from 'react';
import {
    Card, CardBody, Col, Badge, Table,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import BitcoinIcon from 'mdi-react/BitcoinIcon';
import DeleteForeverIcon from 'mdi-react/DeleteForeverIcon';
import PropTypes from 'prop-types';
import { cancelReservation } from '../../../redux/actions/domainsActions';
import { connect } from 'react-redux';
import { Domains } from '../../../services/Domains';
import withErrorNotification from '../../../hof/withErrorNotification';
import Notifications from '../../../hof/notifications';
import moment from 'moment';

const preparePaymentLink = (price, asset, reservationId) => {
    const payload = {
        register: reservationId
    }
    return `https://hivesigner.com/sign/transfer?to=engrave&amount=${price}%20${asset}&memo=${encodeURIComponent(JSON.stringify(payload))}`
}

const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}

const DomainsTable = ({ t, domains, onCancelReservation}) => (
    <Col md={12} lg={12}>
        <Card>
            <CardBody>
                <div className="card__title">
                    <h5 className="bold-text">{t('domains.your_domains.title')}</h5>
                </div>
                {!!domains.length && <Table responsive className="table--bordered">
                    <thead>
                    <tr>
                        <th>{t('domains.your_domains.order_id')}</th>
                        <th>{t('domains.your_domains.domain')}</th>
                        <th>{t('domains.your_domains.registration_date')}</th>
                        <th>{t('domains.your_domains.expiration_date')}</th>
                        <th>{t('domains.your_domains.price_hive')}</th>
                        <th>{t('domains.your_domains.price_hbd')}</th>
                        <th>{t('domains.your_domains.status')}</th>
                        <th>{t('domains.your_domains.action')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {domains && domains.map( (domain) => {
                        return (<tr key={domain._id}>
                            <td title={domain._id}>{`${domain._id.substring(0, 7)}...${domain._id.substring(domain._id.length - 7, domain._id.length)}`}</td>
                            <td>{domain.domain}</td>
                            <td>{domain.creationDate ? moment(domain.creationDate).format('ll') : '-'}</td>
                            <td>{domain.expirationDate ? moment(domain.expirationDate).format('ll') : '-'}</td>
                            <td>{domain.purchasePrice.hive}</td>
                            <td>{domain.purchasePrice.hbd}</td>
                            {domain.paid
                                ? <td><Badge color="primary">{t('domains.your_domains.status_registered')}</Badge></td>
                                : <td><Badge color="success">{t('domains.your_domains.status_awaiting_payment')}</Badge></td>
                            }
                            <td>
                                {!domain.paid && <>
                                    <button className="cart__table-btn" style={{margin: "4px"}} type="button" onClick={() => {
                                        const url = preparePaymentLink(domain.purchasePrice.hive, 'HIVE', domain._id);
                                        openInNewTab(url);
                                    }
                                    }>
                                        <BitcoinIcon /> {t('domains.your_domains.pay_with_hive')}
                                    </button>
                                    <button className="cart__table-btn" type="button" style={{margin: "4px"}}  onClick={() => {
                                        const url = preparePaymentLink(domain.purchasePrice.hbd, 'HBD', domain._id);
                                        openInNewTab(url);
                                    }
                                    }>
                                        <BitcoinIcon /> {t('domains.your_domains.pay_with_hbd')}
                                    </button>
                                    <button className="cart__table-btn" type="button" style={{margin: "0px 4px"}}  onClick={ async () => {
                                        await withErrorNotification(async() => {
                                            await Domains.cancelReservation(domain._id);
                                            onCancelReservation(domain);
                                            Notifications.showNotification(
                                                t('domains.your_domains.messages.reservation_removed.title'),
                                                t('domains.your_domains.messages.reservation_removed.body'),
                                                Notifications.Colors.SUCCESS);
                                        });
                                    }
                                    }>
                                        <DeleteForeverIcon /> {t('domains.your_domains.cancel')}
                                    </button>
                                </>}
                            </td>
                        </tr>)
                    })}
                    </tbody>
                </Table>}
                {!domains.length && <p>{t('domains.your_domains.dont_have_any_domains')}</p>}
            </CardBody>
        </Card>
    </Col>
);

DomainsTable.propTypes = {
    t: PropTypes.func.isRequired,
};

const mapsDispatchToProps = (dispatch) => {
    return {
        onCancelReservation: (domain) => dispatch(cancelReservation(domain))
    }
}
export default connect(null, mapsDispatchToProps)(withTranslation('dashboard')(DomainsTable));
